import { i18n } from "@/locales/setup.js"

/**
 * Errors factory generates error messages in proper language
 * @returns Object where property errors is an Array of error messages
 */

export default ({
	code = "general",
	locale = window.localStorage["covergo-locale"] || "en-US"
}) => ({
	errors: [i18n.messages[locale].errors[code]]
})
